export const baseURL="https://api.themoviedb.org/3";
export const API_KEY="386e50e1450a99887be6f8c8c911593d";
export const imageURL="https://image.tmdb.org/t/p/original"